import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";
import { AuthFormButton } from "src/page-components/auth/AuthFormButton";
import { cloneActionButtonsTrns } from "src/page-components/cabinet/my-clones/CloneSettings/trns";
import { ConfirmationPopupV2 } from "src/components/ConfirmationPopupV2";
import { Button } from "src/components/Button";
import { scrollTop } from "src/utils/scrollTop";
import { PATHNAMES } from "src/constants/routes";
import { ButtonVariants } from "src/components/Button/types";

const DEFAULT_BUTTON_CLASSNAME = "max-w-37.5 px-10 !py-3.5 font-medium";

export const ActionButtons = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const confirmationPopup = useModal(false);

  const onConfirm = () => {
    scrollTop();
    navigate(PATHNAMES.HOME);
  };

  return (
    <div className="flex gap-10 justify-end">
      <Button
        className={DEFAULT_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={confirmationPopup.openModal}
        type="button"
      >
        {t(cloneActionButtonsTrns.cancelButton)}
      </Button>

      <AuthFormButton className={DEFAULT_BUTTON_CLASSNAME}>
        {t(cloneActionButtonsTrns.publishButton)}
      </AuthFormButton>

      <ConfirmationPopupV2 {...confirmationPopup} onConfirm={onConfirm} />
    </div>
  );
};
